import { createSignupModal } from './signup-modal.js';

export function createNavigation(): string {
  return `
    <!-- Navigation -->
    <nav class="navbar">
        <div class="nav-container">
            <div class="nav-brand">
                <a href="/" style="text-decoration: none; color: inherit;" class="nav-brand-link">
                    <img src="./assets/logo_shadow.png" alt="VibeChk Logo" class="nav-logo" />
                    <span class="vibechk-brand">VibeChk</span>
                </a>
            </div>
            <div class="nav-right">
                <!-- Desktop Navigation Links -->
                <ul class="nav-links nav-links-desktop">
                    <li><a href="/" class="nav-link">Home</a></li>
                    <li><a href="/about" class="nav-link">About</a></li>
                    <li><a href="/contact" class="nav-link">Contact</a></li>
                </ul>
                <!-- Desktop App Store Button -->
                <!-- <button onclick="openSignupModal()" class="nav-app-store-btn nav-app-store-desktop"> -->
                <a href="https://apps.apple.com/us/app/vibechk/id6748249688" target="_blank" rel="noopener noreferrer" class="nav-app-store-btn nav-app-store-desktop">
                    <svg class="app-store-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <div class="app-store-text">
                        <span class="app-store-small">Get it on</span>
                        <span class="app-store-large">App Store</span>
                    </div>
                </a>
                <!-- </button> -->
                
                <!-- Mobile Hamburger Button -->
                <button class="hamburger-btn" aria-label="Toggle navigation menu" aria-expanded="false">
                    <span class="hamburger-line"></span>
                    <span class="hamburger-line"></span>
                    <span class="hamburger-line"></span>
                </button>
            </div>
        </div>
        
        <!-- Mobile Navigation Menu -->
        <div class="mobile-nav-menu" id="mobile-nav-menu">
            <div class="mobile-nav-content">
                <ul class="mobile-nav-links">
                    <li><a href="/" class="mobile-nav-link">Home</a></li>
                    <li><a href="/about" class="mobile-nav-link">About</a></li>
                    <li><a href="/contact" class="mobile-nav-link">Contact</a></li>
                </ul>
                <!-- Mobile App Store Button -->
                <!-- <button onclick="openSignupModal()" class="nav-app-store-btn nav-app-store-mobile"> -->
                <a href="https://apps.apple.com/us/app/vibechk/id6748249688" target="_blank" rel="noopener noreferrer" class="nav-app-store-btn nav-app-store-mobile">
                    <svg class="app-store-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <div class="app-store-text">
                        <span class="app-store-small">Get it on</span>
                        <span class="app-store-large">App Store</span>
                    </div>
                </a>
                <!-- </button> -->
            </div>
        </div>
    </nav>
    
    ${createSignupModal()}
  `;
} 